var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { Inline } from "syf-component-library/ui/spacing";
import { formatCurrency } from "syf-js-utilities";
import { RowInset, RowSubItem } from "./subcomponents";
import { FieldValue } from "../subcomponents";
import getTranslation from "../../../strings/getTranslations";
var Income = function (_a) {
    var _b;
    var data = _a.data;
    var t = getTranslation().t;
    var income = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b["cipher.annualNetIncome"];
    var parsedCurrency = Number(income)
        ? formatCurrency(income)
        : income;
    var windowWidth = useWindowSize();
    return income ? (_jsxs(RowInset, __assign({ top: "medium", bottom: "medium", "data-private": true }, { children: [!windowWidth.isLessThanTablet && (_jsxs(_Fragment, { children: [_jsx(RowSubItem, __assign({ "data-cy": "incomeSubtitle" }, { children: t("labels.annualIncome") })), _jsx(Inline, { size: "xxlarge" }), _jsx(Inline, { size: "xxlarge" })] })), _jsx(FieldValue, { children: parsedCurrency })] }))) : null;
};
export default Income;
